import React from 'react';
import PropTypes from 'prop-types';

import { isBlank } from 'helpers/string_helpers';

export class SavedSearchForm extends React.Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  state = {
    name: ""
  }

  handleInput = e => this.setState({ name: e.target.value });

  render() {
    const { name } = this.state;
    const { onSave, onCancel } = this.props;
    const disabledSave = isBlank(name);
    return (
      <div>
        <h5 className="bold">Save this Search As: </h5>
        <div className="mb-3">
          <input
            className="form-group w-100 p-2"
            placeholder="Enter name for search"
            onChange={this.handleInput}
          />

          <div className="pull-right d-inline-flex">
            <div className="clickable btn btn-sm" onClick={onCancel}>Cancel</div>
            <div
              className="btn btn-sm btn-save"
              disabled={disabledSave}
              onClick={!disabledSave && (() => onSave(name))}
            >
              Save
            </div>
          </div>
        </div>
      </div>
    );
  }
}